(function ($, Drupal, window, document) {

  'use strict';

  Drupal.behaviors.paragraph_tabs = {
    attach: function (context, settings) {

      if (typeof context['location'] !== 'undefined') {

        $(function() {

          //initial (mobile)
          //set active class to first item with alpha
          $("[data-item-scroll=alpha]").addClass('active');
          //get text/html from first element and set to paragraph_menu--title
          $('.paragraphs_menu--title').text($("[data-item-scroll=alpha]").html());
          $('.paragraphs_menu--title').click(function() {
              $(this).next('.paragraphs_menu--tabs').slideToggle(300);

          });


          $('.paragraphs_menu--tabs').clone().prependTo("#paragraphs-menu-wrap");
          var product_menu_tabs;
          var product_menu_tabs_height;
          product_menu_tabs = $('.paragraphs_menu--tabs li');
          product_menu_tabs_height = $('.paragraphs_menu .paragraphs_menu--tabs').height();

          $('#paragraphs-menu-wrap .paragraphs_menu--tabs').css({"top": -product_menu_tabs_height});

          product_menu_tabs.click(function() {

            //set text to paragraphs_menu--title
            $('.paragraphs_menu--title').text($(this).html());
            //remove all active classes
            $('.paragraphs_menu--tabs li').removeClass('active');

            var anchor = $(this).attr('data-item-scroll');
            var anchorSelector = "[data-item-scroll=" + anchor + "]"

            $(anchorSelector).addClass('active');
            var offset;
            anchor = '#'+anchor;
            offset = $(anchor).offset().top - product_menu_tabs_height + 1;

            $('html,body').animate({
                scrollTop: offset
            }, 500);

            // if($window.width() < 768) {
            if($(window).width() < 768) {
              $('.paragraphs_menu--tabs').hide();
            }

          });
        });
      }
    }
  };

  Drupal.behaviors.paragraph_menu_scroll = {
    attach: function (context, settings) {
      if (typeof context['location'] !== 'undefined') {

        var paragraph_menu = $('.paragraphs_menu--tabs');
        var $window = $(window);

        $window.scroll(function (e) {
          if ($window.scrollTop() >= $(paragraph_menu[0]).position().top) {
            $('#paragraphs-menu-wrap').addClass('sticky');
            $('#paragraphs-menu-wrap .paragraphs_menu--tabs').addClass('fixed');
          }

          if (
            $window.scrollTop() < $(paragraph_menu[0]).position().top ||
            $window.scrollTop() >= $($('.region-footer')[0]).position().top
          ) {
            $('#paragraphs-menu-wrap').removeClass('sticky');
            $('#paragraphs-menu-wrap .paragraphs_menu--tabs').removeClass('fixed');
          }

          // if () {
          //   $('#paragraphs-menu-wrap').removeClass('sticky');
          //   $('#paragraphs-menu-wrap .paragraphs_menu--tabs').removeClass('fixed');
          // }

        });

        var ids = [];
        var static = ["document-search", "faq", "events", "panels", "insight-articles", "related-products", "bioz-prime", "product-support-distributor"];

        $('*[id^="pg-menu-item-"]').each(function(_, $el) {
          ids.push($el.id);
        });

        static.forEach(function(st) {
          if (document.getElementById(st)) ids.push(st);
        })

        ids.forEach(function(id, i) {
          $(once('waypoint', '#' + id)).waypoint({
            handler: function(dir) {
              if (dir === "down") {
                $('.paragraphs_menu--tabs').find('li').each(function(_, $el) {
                  $($el).removeClass('active')
                  if ($el.dataset.itemScroll === ids[i]) {
                    $($el).addClass('active');
                    $('.paragraphs_menu--title').text($($el).text());
                  }
                })
              } else {
                $('.paragraphs_menu--tabs').find('li').each(function(_, $el) {
                  if (i !== 0) {
                    $($el).removeClass('active')
                    if ($el.dataset.itemScroll === ids[i - 1]) {
                      $($el).addClass('active')
                      $('.paragraphs_menu--title').text($($el).text());
                    }
                  }
                })
              }
            },
            offset: 121,
          })
        })
      }
    }
  }

  // console.log($(window).width());
  //mobile scroll
  Drupal.behaviors.paragraph_menu_mobile = {
    attach: function (context, settings) {
      var menu_title = $('.paragraphs_menu--title')[0];
      var $window = $(window);
      var menu_title_position = $(menu_title).position().top;
      var paragraph_height_helper = $('#paragraph_height_helper');
      var paragraph_height_helper_position = $(paragraph_height_helper).position().top;

      if($window.width() < 768) {

        $window.scroll(function () {
          if ($window.scrollTop() >= menu_title_position) {
            $('.paragraphs .paragraphs_menu--header').addClass('fixed');
          }
          if ($window.scrollTop() < menu_title_position || $window.scrollTop() > paragraph_height_helper_position) {
            $('.paragraphs .paragraphs_menu--header').removeClass('fixed');
          }
        });
      }
    }
  }




})(jQuery, Drupal, this, this.document);
